import "../../styles/UserDashboard/SellEnergy.scss";
import SideBar from "../../components/UserDashboard/SideBar";
import EnergyHeader from "../../components/energy/energyHeader";
import { useNavigate } from "react-router-dom";
import { usePaystackPayment } from "react-paystack";

export default function PayForEnergy() {
  const navigate = useNavigate();

    const configPaystack = {
      // reference: (new Date()).getTime().toString(),
      email: "saleemjibril5@gmail.com",
      amount: 200 * 100, //Amount is in the country's lowest currency. E.g Kobo, so 20000 kobo = N200
      metadata: {
        firstName: "Saleem",
        lastName: "Jibril",
        email: "saleemjibril5@gmail.com",
        phone: "08055553569",
      },
      // publicKey: "pk_test_3f715236ee25c842649abc6a3c013258a37f9b1c",
      publicKey: "pk_live_6a7e7c0b5677117392f596dff24695cbd0dd2eb0",
      text: "Pay Now",
    };
  
    const initializePayment = usePaystackPayment(configPaystack);
  
  
  
    const onSuccess = (response) => {
      console.log("response response", response);
      // handleVerifyDonation();
      // handleCallBack(response?.reference);
    };
  
    const onClose = () => alert("Are you want to cancel this transaction");
  
  
  return (
    <div className="sellEnergy">
      <div className="sidebar_container">
        <SideBar />
      </div>
      <div className="sellEnergy__inner">
        <EnergyHeader />

        <div className="sellEnergy__inner__card">
          <div className="sellEnergy__inner__card__header">
          <div className="sellEnergy__inner__card__header__title">
          Confirm Energy details
            </div>
        

            <div className="sellEnergy__inner__card__header__rate">
            ₦1,350 / kWh
            </div>
          </div>

          <div className="sellEnergy__inner__card__cards">
            <div className="sellEnergy__inner__card__cards__card1">
            
            <div className="sellEnergy__inner__card__header__user">
              <div className="sellEnergy__inner__card__header__user__icon">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 15C1 13.9391 1.42143 12.9217 2.17157 12.1716C2.92172 11.4214 3.93913 11 5 11H13C14.0609 11 15.0783 11.4214 15.8284 12.1716C16.5786 12.9217 17 13.9391 17 15C17 15.5304 16.7893 16.0391 16.4142 16.4142C16.0391 16.7893 15.5304 17 15 17H3C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15Z"
                    stroke="#2C9963"
                    stroke-width="2"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9 7C10.6569 7 12 5.65685 12 4C12 2.34315 10.6569 1 9 1C7.34315 1 6 2.34315 6 4C6 5.65685 7.34315 7 9 7Z"
                    stroke="#2C9963"
                    stroke-width="2"
                  />
                </svg>
              </div>

            <div>
            <div className="sellEnergy__inner__card__header__user__title">
                House 83
              </div>
              <div className="sellEnergy__inner__card__header__user__subtitle">
                Location: <span>House ABC, Abuja </span>
              </div>
            </div>
            </div>
              <div className="sellEnergy__inner__card__cards__card1__info-bold">
                <div>Want to sell</div>
                <div>800 kWh</div>
                  {/* <div>{values?.amountTo} kWh</div> */}

              </div>
              <div className="sellEnergy__inner__card__cards__card1__info-bold">
                <div>You will pay</div>
                <div> ₦1,080,000</div>
              </div>
              <div className="sellEnergy__inner__card__cards__card1__info-bold">
                <div>State</div>
                <div>Abuja</div>
              </div>
              <div className="sellEnergy__inner__card__cards__card1__info-bold">
                <div>House number</div>
                <div>House 83</div>
              </div>
              <div className="sellEnergy__inner__card__cards__card1__info-bold">
                <div>Address</div>
                <div>House ABC</div>
              </div>
            </div>
            <div className="sellEnergy__inner__card__cards__card2">
            <div className="sellEnergy__inner__card__cards__card1__info">
                <div>Payment time limit</div>
                <div>30mins</div>
              </div>
              <div className="sellEnergy__inner__card__cards__card1__info">
                <div>Payment method</div>
                <div>Paystack</div>
              </div>
              <div className="sellEnergy__inner__card__cards__card1__info">
                <div>Order number</div>
                <div>9720200ffek12o4h0</div>
              </div>
              <br />
              <br />
                <div className="sellEnergy__inner__card__cards__card2__terms">
                <input type="checkbox" name="" id="" />
                <div>I agree to the <a href="">Terms of Service</a></div>
              </div>

              

              <button
              // onClick={() => navigate("/energy")}
              onClick={() => initializePayment(onSuccess, onClose)}
              >
                Proceed to Pay
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
